import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Partnerships: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleContactClick = () => {
    navigate('/#contact');
  };

  return (
    <>
      {/* Hero Section */}
      <section className="relative h-[50vh] bg-gradient-to-r from-blue-900 to-blue-700 flex items-center overflow-hidden">
        <div className="container mx-auto px-4 z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
              Our Partners
            </h1>
            <p className="text-xl text-blue-100">
              Working together to strengthen our community
            </p>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          {/* MNG Ministry — full width */}
          <div className="max-w-6xl mx-auto mb-12">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="p-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">MNG Ministry</h2>
                <h3 className="text-xl text-blue-600 mb-6">Radical Generosity. 100% to Mission.</h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2">Why We Give</h4>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      We're a growing brotherhood of 150+ men across 10+ groups, multiple states, and counting, committed to one simple conviction: every dollar given goes where it's needed most. 100% of every donation flows directly into mission work — no overhead, no admin costs, no exceptions. Everything we do is rooted in our faith in Jesus Christ and a shared desire to honor the Lord through radical generosity.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2">How We Give</h4>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      Giving isn't impersonal here. We stay close to the ground, constantly looking for opportunities to bless others through genuine relationships and prayerful discernment. When a need or opportunity arises, our board evaluates it carefully and votes to determine where funds will have the greatest impact.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-2">Where We Give</h4>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      Our giving reaches across the globe and right into the hardest places. We partner with trusted 501(c)(3) organizations like Destiny Rescue to fight human trafficking, care for orphans, support international missions, and fund ministry opportunities wherever they emerge. Whether it's boots on the ground overseas or meeting a need in our own backyard, we show up.
                    </p>
                  </div>
                </div>

                <a
                  href="https://givebutter.com/mng-giving-fund-zevbt6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
                >
                  Give to MNG Ministry
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {/* Destiny Rescue */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="p-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Destiny Rescue</h2>
                <h3 className="text-xl text-blue-600 mb-6">Rescuing Children. Restoring Hope.</h3>
                
                <p className="text-gray-700 mb-6">
                  Destiny Rescue is an internationally-recognized Christian non-profit organization dedicated to rescuing children trapped in sexual exploitation and trafficking. Through rescue, rehabilitation, and reintegration, they work to give children a future free from exploitation.
                </p>
                
                <div className="mt-8">
                  <h4 className="text-xl font-bold text-gray-900 mb-4">Support Our Mission</h4>
                  <p className="text-gray-700 mb-6">
                    Join us in making a difference. Your donation helps rescue and restore precious lives from trafficking and exploitation.
                  </p>
                  <a 
                    href="https://irescue-us.raiselysite.com/t/monday-night-mens-group"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
                  >
                    Donate to Save a Child
                  </a>
                </div>
              </div>
            </div>

            {/* One Generation Away */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="p-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">One Generation Away</h2>
                <h3 className="text-xl text-blue-600 mb-6">Wiping Hunger Off the Face of America</h3>
                
                <p className="text-gray-700 mb-6">
                  One Generation Away is a compassionate community resource dedicated to wiping hunger off the face of America. They rescue high-quality food from grocery stores, restaurants, caterers, and farms, then distribute it to neighbors in need — no questions asked.
                </p>
                
                <div className="mt-8">
                  <h4 className="text-xl font-bold text-gray-900 mb-4">Get Involved</h4>
                  <p className="text-gray-700 mb-6">
                    Help us fight hunger in our community. One Generation Away provides fresh produce, pantry staples, and more to different neighborhoods through their Mobile Pantry program.
                  </p>
                  <a 
                    href="https://www.onegenaway.com/donate"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors"
                  >
                    Learn More & Donate
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <button
              onClick={handleContactClick}
              className="inline-block text-blue-600 hover:text-blue-800 font-medium transition-colors duration-300"
            >
              Contact us to learn more about our partnerships
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Partnerships;